import { IUserContext } from "../common/types";

enum ChilipiperRouter {
    CU_ROUTER_FRO_HOOKS = "cu_fro_hooks_2024",
}

declare global {
    interface Window {
        ChiliPiper: IChiliPiper;
    }
}
interface IChiliPiper {
    submit: (
        domain: string,
        router: string,
        options?: {
            lead: { [key: string]: string | number };
            handleSubmit?: boolean;
            formId?: string;
            debug?: boolean;
            map?: boolean;
            domain?: string;
            router?: string;
            title?: string;
            titleStyle?: string;
            onSuccess?: () => void;
            onError?: () => void;
            onClose?: () => void;
            onRouted?: () => void;
            closeOnOutside?: boolean;
            dynamicRedirectLink?: string;
            mobileRedirectLink?: string;
            injectRootCss?: boolean;
            locale?: string;
            webHook?: string; // (url)
        },
    ) => void;
}
export const handleChiliPiperSubmit = (
    ev: MessageEvent<{ op: string; data: IUserContext; chiliPiperRouter?: string }>,
) => {
    const params = ev.data.data;
    const source = ev.source as Window;
    if (window.ChiliPiper) {
        window.ChiliPiper.submit(
            "similarweb",
            ev.data.chiliPiperRouter ? ev.data.chiliPiperRouter : ChilipiperRouter.CU_ROUTER_FRO_HOOKS,
            {
                lead: {
                    //need to be part of configuration and not reside here
                    FirstName: params.firstName,
                    LastName: params.lastName,
                    Email: params.email,
                    Employees_Min__c: params.employeesMin,
                    Employees_Max__c: params.employeesMax,
                },
                map: true,
                closeOnOutside: true,
                onError: () => source.postMessage({ op: "chili-error" }, "*"),
                onClose: () => source.postMessage({ op: "chili-close" }, "*"),
                onSuccess: () => source.postMessage({ op: "chili-success" }, "*"),
            },
        );
    } else {
        console.warn(`window.ChiliPiper not installed. Cannot proceed with chilipiper. Was called for: `, params);
        source.postMessage({ op: "chili-none" }, "*");
    }
};
